import React from "react";
import useTransitionStore from "../../../../state/transitions";
const Tunnel = React.lazy(() => import("./Tunnel"));

const TunnelContainer = ({
  floorOffset = -0.935,
  xOffset = 0,
  zOffset = 0,
  rotationY = Math.PI / 2,
  visibleOverride,
  forceVisible = false,
  useLightmapsOverride,
}) => {
  const DisplayMode = useTransitionStore((state) => state.DisplayMode);
  const SuspensionMode = useTransitionStore((state) => state.SuspensionMode);
  const isVisible =
    visibleOverride ?? (DisplayMode !== "interior" && !SuspensionMode);

  return (
    <group>
      <group
        position={[xOffset, floorOffset, zOffset]}
        rotation={[0, rotationY, 0]}
        visible={isVisible}
      >
        <Tunnel
          forceVisible={forceVisible}
          useLightmapsOverride={useLightmapsOverride}
        />
      </group>
    </group>
  );
};

export default TunnelContainer;
